export default __webpack_public_path__ + "static/media/resource-unavailable-guy.ac6ad0b5.png";